
<div id="info">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeId" class="nav-pills">
    <li [ngbNavItem]="0">
      <a ngbNavLink class="d-none">&ensp;</a>
      <ng-template ngbNavContent></ng-template>
    </li>
    @if (zoomScrollIsRelevant===true) {
      <li [ngbNavItem]="1">
        <button type="button" ngbNavLink class="btn btn-secondary rounded-circle" [class.active]="activeId==1" (click)="onTabClick(1)">
            <fa-icon [icon]="faSearchPlus" size="lg"></fa-icon>
        </button>
        <ng-template ngbNavContent>
          <div class="info-box">
            <h5 class="info-box-header">{{ 'xml-report.chart.info.zoom.header' | translate }}</h5>
            <p class="info-box-content" [innerHTML]="'xml-report.chart.info.zoom.content' | translate"></p>
          </div>
        </ng-template>
      </li>
    }
    @if (drillDownInfo.canDrillDown || drillDownInfo.isDrillDowned) {
      <li [ngbNavItem]="2">
          <button type="button" ngbNavLink class="btn btn-secondary rounded-circle" [class.active]="activeId==2" (click)="onTabClick(2)">
              <fa-icon [icon]="faHandPointer" size="lg"></fa-icon>
          </button>
        <ng-template ngbNavContent>
          <div class="info-box">
            <h5 class="info-box-header">{{ 'xml-report.chart.info.drilldown.header' | translate }}</h5>
            @if (drillDownInfo.canDrillDown) {
              <p class="info-box-content" [innerHTML]="'xml-report.chart.info.drilldown.content' | translate"></p>
            }
            @if (drillDownInfo.isDrillDowned) {
              <button type="button" class="btn btn-xs btn-info btn-link d-block my-2"
                (click)='drillUp.emit()'>
                {{ 'xml-report.chart.info.drilldown.back' | translate }} {{  drillDownInfo.drillDownToName?.length > 0 ? 'till "'+drillDownInfo.drillDownToName+'"' : '' }}
              </button>
            }
          </div>
        </ng-template>
      </li>
    }
    @if (elearningInfo) {
      <li [ngbNavItem]="3">
        <button type="button" ngbNavLink class="btn btn-secondary rounded-circle" [class.active]="activeId==3" (click)="onTabClick(3)">
            <fa-icon [icon]="faTv"></fa-icon>
        </button>
        <ng-template ngbNavContent>
          <div class="info-box" style="max-width: 400px">
            <h5 class="info-box-header">{{ 'xml-report.chart.info.elearning.header' | translate }}</h5>
            <div class="responsive-embed">
              <iframe [src]="getIframeSrc(elearningInfo.videoId)" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
          </div>
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
